import type { BetSlipState } from '../types';

const promotionAdded = (state: BetSlipState, payload: string): BetSlipState => ({
  ...state,
  selectedPromotion: payload
});

export default promotionAdded;
